/**
 * Backend `validateTask` answer when a task for this document already exists
 * (e.g. EqxAPI repeated a POST after "Network Error" that had reached the
 * backend). The document is then SUBMITTING or SUBMITTED, never PENDING.
 */
const DUPLICATE_DOCUMENT_TASK = /A task of type (\w+) already exists for document/;

/** Task types whose duplicate means "already sent" (not REJECT_DOCUMENT). */
const SOFT_OK_TASK_TYPES = ['SUBMIT_DOCUMENT', 'UPLOAD_DOCUMENT'];

/** @returns {string|null} task type when the duplicate counts as success */
export const getSoftOkDuplicateTaskType = message => {
  const match = message ? String(message).match(DUPLICATE_DOCUMENT_TASK) : null;
  return match && SOFT_OK_TASK_TYPES.includes(match[1]) ? match[1] : null;
};
